import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from './layout/header/header.component';
import { AccountMenuComponent } from './layout/header/account-menu/account-menu.component';
import { SideNavComponent } from './layout/side-nav/side-nav.component';
import { NavCellComponent } from './layout/side-nav/nav-cell/nav-cell.component';
import { AuthEffects } from './auth/store/auth.effects';
import { CampaignEffects } from './store/campaigns/campaigns.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MessageTemplatesEffects } from './store/message-templates/message-templates.effects';
import { VerifyPhoneComponent } from './layout/header/verify-phone/verify-phone.component';
import { ToastComponent } from './shared/toast/toast.component';
import { ModalsModule } from './modals/modals.module';
import * as fromRoot from '../app/store/app.reducer';
import { UserEffects } from './store/user/user.effects';
import { DebouceSearchInputComponent } from './shared/debouce-search-input/debouce-search-input.component';
import { LeadListEffects } from './store/lead-list/lead-list.effects';
import { TranslateModule } from '@ngx-translate/core';
import { SupportChatComponent } from './chat/support-chat.component';
import { MfeLoaderService, initializeMfeLoader } from './shared/services/mfe-loader.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SideNavComponent,
    NavCellComponent,
    VerifyPhoneComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    SharedModule,
    FormsModule,
    CommonModule,
    ModalsModule,
    ToastComponent,
    AccountMenuComponent,
    BrowserAnimationsModule,
    DebouceSearchInputComponent,
    SupportChatComponent,
    StoreModule.forRoot(fromRoot.appReducer),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([
      AuthEffects,
      CampaignEffects,
      MessageTemplatesEffects,
      UserEffects,
      LeadListEffects,
    ]),
    StoreDevtoolsModule.instrument({ logOnly: environment.production }),
    TranslateModule.forRoot(),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMfeLoader,
      deps: [MfeLoaderService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
